export const extractHrefFromHtmlLink = (html) => {
    if (!html || typeof html !== 'string') {
        return null;
    }

    const match = html.match(/href=["']([^"']+)["']/i);
    return match?.[1] ?? null;
};

export const extractLinkLabelFromHtml = (html) => {
    if (!html || typeof html !== 'string') {
        return null;
    }

    const match = html.match(/>([^<]+)</);
    return match?.[1]?.trim() ?? null;
};

const decodeHtmlEntities = (value) => {
    if (!value || typeof value !== 'string') {
        return value;
    }

    if (typeof document !== 'undefined') {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }

    return value
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
};

const looksLikeEncodedHtml = (value) => (
    /&lt;|&gt;|&amp;|&quot;|&#\d+;|&#x[0-9a-f]+;/i.test(value)
    && !/<[a-z][\s\S]*>/i.test(value)
);

export const normalizeHotYoterHtmlContent = (content) => {
    if (content == null || content === '') {
        return null;
    }

    let html = content;

    if (typeof html === 'object') {
        html = html.html
            ?? html.body
            ?? html.text
            ?? html.value
            ?? html.content
            ?? '';
    }

    html = String(html).trim();

    if (!html) {
        return null;
    }

    while (looksLikeEncodedHtml(html)) {
        const decoded = decodeHtmlEntities(html);
        if (decoded === html) {
            break;
        }
        html = decoded.trim();
    }

    return html;
};

export const removeHtmlAnchorTags = (html) => {
    if (!html || typeof html !== 'string') {
        return html;
    }

    return html.replace(/<a\b[^>]*>[\s\S]*?<\/a>/gi, '').trim();
};
